import { Group, Text } from "@mantine/core";

export const PageFooter = () => {
  return (
    <Group justify="center">
      <Text c="dimmed" fz="sm" component="a" target="_blank">
        &copy;&nbsp;{new Date().getFullYear()}&nbsp;QLKTM
      </Text>
    </Group>
  );
};
